import { render, staticRenderFns } from "./AIAnswer.vue?vue&type=template&id=fcf23c98&scoped=true"
import script from "./AIAnswer.vue?vue&type=script&lang=js"
export * from "./AIAnswer.vue?vue&type=script&lang=js"
import style0 from "./AIAnswer.vue?vue&type=style&index=0&id=fcf23c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf23c98",
  null
  
)

export default component.exports